import React from "react";

function PeethaCard({ name, image, description, part, significance, mapLink }) {
  const summary =
    description && description.length > 150
      ? description.slice(0, 147) + "..."
      : description;

  return (
    <div className="bg-white rounded-2xl shadow-md hover:shadow-2xl hover:-translate-y-2 transition-all duration-300 overflow-hidden border border-orange-200 h-full flex flex-col">

      {/* Image */}
      <img
        src={image}
        alt={name}
        className="w-full h-56 object-cover rounded-t-2xl"
        loading="lazy"
      />

      {/* Content */}
      <div className="p-5 text-center flex flex-col flex-grow">

        {/* Temple Name */}
        <h2 className="text-2xl font-serif font-bold text-orange-800">
          {name}
        </h2>

        {/* Story */}
        <p className="text-gray-700 mt-3 text-sm font-sans leading-relaxed">
          {summary}
        </p>

        {/* Fixed Height Section */}
        <div className="mt-4 text-sm font-sans text-gray-800 min-h-[140px]">
          <p>
            <span className="font-semibold text-orange-600">
              Part that fell:
            </span>{" "}
            {part}
          </p>

          <p>
            <span className="font-semibold text-orange-600">
              Significance:
            </span>{" "}
            {significance}
          </p>
        </div>

        {/* Button Section */}
        <div className="mt-auto pt-4">
          <div className="flex items-center justify-center gap-3">
            <a
              href={mapLink}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center bg-orange-600 text-white px-5 py-2 rounded-lg hover:bg-orange-700 transition font-medium"
            >
              More Information
            </a>
          </div>

         
        </div>
      </div>
    </div>
  );
}

export default PeethaCard;
